import Net from '../lib/net';
import { DB, Stores } from '../db/dbschema';
const glHostName = require('../config').config.glHostName;

export function GetTriggers(cb) {
  _getDataFromLocalDB(Stores.Triggers, (err, triggers) => {
    if (err) cb(err);
    else {
      if (triggers && triggers.length) cb(null, triggers);
      else _getTriggersFromServer(cb);
    }
  });
}

function _getTriggersFromServer(cb) {
  var url = glHostName + '/gl/users/triggers/getTriggerData';
  Net.PostRequest(url, {}, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status === 200) {
      if (data.length) {
        _saveDataInLocalDB(Stores.Triggers, data, cb)
      } else cb(null, data);
    }
    else {
      console.error(data);
      cb("Error while getting triggers");
    }
  });
}

function _getDataFromLocalDB(storeNm, cb) {
  global.indexedDbClient.getAllRecords(DB.GL, storeNm)
    .then((resp) => {
      cb(null, resp);
    })
    .catch((e) => {
      console.error("Error while getting triggers from indexed DB " + e);
      cb(e);
    })
}

function _saveDataInLocalDB(storeNm, data, cb) {
  global.indexedDbClient.addMultipleRecords(DB.GL, storeNm, data , true)
    .then(() => {
      cb(null, data);
    })
    .catch((e) => {
      console.error(e);
      cb(null, data)
    })
}

export function GetTriggersData(type, cb) {
  global.indexedDbClient.getAllRecords(DB.GL, Stores.Triggers, 'typ', type)
    .then((resp) => {
      cb(null, resp);
    })
    .catch((e) => {
      console.error("Error while getting triggers from indexed DB " + e);
      cb(e);
    })
}

export function GetGeoFenceTypes(cb) {
  _getDataFromLocalDB(Stores.GeoFenceTypes, (err, geofences) => {
    if (err) cb(err);
    else {
      if (geofences && geofences.length) cb(null, geofences);
      else _getGeoFenceTypesFromServer(cb);
    }
  });
}

function _getGeoFenceTypesFromServer(cb) {
  var url = glHostName + '/gl/users/triggers/getGeoFenceType';
  Net.GetRequest(url, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status === 200) {
      if (data.length) {
        _saveDataInLocalDB(Stores.GeoFenceTypes, data, cb)
      } else cb(null, data);
    }
    else {
      console.error(data);
      cb("Error while getting geo fences types");
    }
  });
};

export function saveTrigger(trigger, cb) {
  var url = glHostName + '/gl/users/triggers/insertTrigger';
  Net.PostRequest(url, trigger, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status !== 200) {
      cb(data, null);
    }
    else {
      trigger.idx = data;
      _saveDataInLocalDB(Stores.Triggers, [trigger], cb);
    }
  });
}

export function deleteTrigger(trigger, cb) {
  var url = glHostName + '/gl/users/triggers/deletetrigger';
  Net.PostRequest(url, trigger, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status !== 200) {
      cb(data, null);
    }
    else {
      global.indexedDbClient.deleteRecord(DB.GL, Stores.Triggers, trigger.idx )
        .then(() => {
          cb(null, data);
        })
        .catch((e) => {
          console.error("Error while deleting triggers from indexed DB " + e);
          cb(e);
        })
    }
  });
}

export function editTrigger(data, typ, cb) {
  var url = glHostName + '/gl/users/triggers/updatetrigger';
  Net.PostRequest(url, data, (resp) => {
    var response = JSON.parse(resp.response).data;
    if (resp.status !== 200) {
      cb(response, null)
    }
    else {
      if (typ && typ === 1) _updateSLById(data, cb);
      else _updateGFById(data, cb);
    }
  });
}

function _updateGFById(data, cb) {
  global.indexedDbClient.getValueByKey(DB.GL, Stores.Triggers, data.idx)
    .then((tidData) => {
      if (data.title) tidData.title = data.title;
      if (data.clat) tidData.clat = data.clat;
      if (data.clong) tidData.clong = data.clong;
      if (data.r) tidData.r = data.r;
      if (data.desc) tidData.desc = data.desc;
      if (data.vehIdArr) tidData.vehIdArr = data.vehIdArr;
      if (data.gfTyp) tidData.gfTyp = data.gfTyp;
      _saveDataInLocalDB(Stores.Triggers, [tidData], cb);
    })
    .catch((e) => {
      console.error("Error while updating trigger in indexed DB " + e);
      cb(e);
    })
}

function _updateSLById(data, cb) {
  global.indexedDbClient.getValueByKey(DB.GL, Stores.Triggers, data.idx)
    .then((tidData) => {
      if (data.title) tidData.title = data.title;
      if (data.spdLmt) tidData.spdLmt = data.spdLmt;
      if (data.vehIdArr) tidData.vehIdArr = data.vehIdArr;
      if (data.thrshld) tidData.thrshld = data.thrshld;
      _saveDataInLocalDB(Stores.Triggers, [tidData], cb);
    })
    .catch((e) => {
      console.error("Error while updating trigger in indexed DB " + e);
      cb(e);
    })
}

export function addNewGeoFenceType(newTyp, cb) {
  GetGeoFenceTypes((err, geoFencesTypes) => {
    if (err) cb(err);
    else {
      if (geoFencesTypes && geoFencesTypes.length) {
        var exist = geoFencesTypes.find((typ) => { return typ.nm === newTyp.nm });
        if (exist) {
          cb("Geofence type already exist");
          return;
        }
      }

      var url = glHostName + '/gl/users/triggers/addGeoFenceType';
      Net.PostRequest(url, newTyp, (resp) => {
        var data = JSON.parse(resp.response).data;
        if (resp.status !== 200) {
          cb(data, null);
        }
        else {
          newTyp.idx = data.idx;
          _saveDataInLocalDB(Stores.GeoFenceTypes, [newTyp], cb)
        }
      });
    }
  });
}